import { render, staticRenderFns } from "./MyApp.vue?vue&type=template&id=dc279cf6&scoped=true&"
import script from "./MyApp.vue?vue&type=script&lang=js&"
export * from "./MyApp.vue?vue&type=script&lang=js&"
import style0 from "./MyApp.vue?vue&type=style&index=0&id=dc279cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc279cf6",
  null
  
)

export default component.exports